import HostControlZoom from './HostControlZoom';

export default HostControlZoom;
